import { RouterOutlet } from "@angular/router";
import { SidebarComponent } from "../../../shared/components/sidebar/sidebar.component";
import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  standalone: true,
  selector: 'app-main-layout',
  imports: [
    RouterOutlet,
    SidebarComponent,
    CommonModule
],
  templateUrl:'./main-layout.component.html'
})
export class MainLayoutComponent {

  isSidebarCollapsed = false
  isMobileSidebarOpen = false

  sidebarToggle(value: any) {
    console.log(value)
    this.isSidebarCollapsed = value
  }

  toggleMobileSidebar() {
    this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
  }

  closeMobileSidebar() {
    this.isMobileSidebarOpen = false;
  }
    
}
